export const globalPerf = window.performance;
export const initialMetrics = window.__tcc_bm_metrics || {};
